import { union } from "polygon-clipping";
import type {
  Polygon as ClippingPolygon,
  Ring as ClippingRing,
} from "polygon-clipping";
import type { PolygonPiece, PolygonRing } from "../types";
import type { UnionPolygons } from "./types";

// polygon-clipping wants [x, y] rings closed with a repeated first point; ours are {x, y} and open.
const toClippingRing = (ring: PolygonRing): ClippingRing => [
  ...ring.map((point): [number, number] => [point.x, point.y]),
  [ring[0].x, ring[0].y],
];

const fromClippingRing = (ring: ClippingRing): PolygonRing => {
  const [firstX, firstY] = ring[0];
  const [lastX, lastY] = ring[ring.length - 1];
  const isClosed = ring.length > 1 && firstX === lastX && firstY === lastY;
  return (isClosed ? ring.slice(0, -1) : ring).map(([x, y]) => ({ x, y }));
};

const toClippingPolygon = (piece: PolygonPiece): ClippingPolygon =>
  piece.map(toClippingRing);

const fromClippingPolygon = (polygon: ClippingPolygon): PolygonPiece =>
  polygon.map(fromClippingRing);

export const unionPolygons: UnionPolygons = ({ pieces }) => {
  if (pieces.length === 0) return [];
  const [first, ...rest] = pieces.map(toClippingPolygon);
  return union(first, ...rest).map(fromClippingPolygon);
};
